import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill, spring } from "remotion";
import { loadFont as loadInter } from "@remotion/google-fonts/Inter";
const { fontFamily: inter } = loadInter("normal", { weights: ["700","800"], subsets: ["latin"] });

// Portrait LS Variant 3 — Slide in from left, stacked pill buttons
export const ReelLS3: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const s = spring({ frame, fps, config: { damping:14, stiffness:100 }, durationInFrames: Math.round(fps*1.2) });
  const slideX = interpolate(s, [0,1], [-220, 0]);
  const fadeOut = interpolate(frame, [Math.round(fps*5), Math.round(fps*6)], [1,0], { extrapolateLeft:"clamp", extrapolateRight:"clamp" });
  const likeClicked = frame >= Math.round(fps*1.5);
  const subClicked  = frame >= Math.round(fps*2.2);
  const likeS = interpolate(frame, [Math.round(fps*1.5), Math.round(fps*1.58), Math.round(fps*1.7)], [1,0.87,1.05], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const subS  = interpolate(frame, [Math.round(fps*2.2), Math.round(fps*2.28), Math.round(fps*2.4)], [1,0.87,1.05], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  return (
    <AbsoluteFill style={{ overflow:"hidden" }}>
      <div style={{ position:"absolute", inset:0, opacity: fadeOut }}>
        <div style={{ position:"absolute", top:"50%", left:0, transform:`translateY(-50%) translateX(${slideX}px)`, display:"flex", flexDirection:"column", gap:8 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, background: likeClicked?"#1a73e8":"rgba(0,0,0,0.8)", backdropFilter:"blur(8px)", borderRadius:"0 24px 24px 0", padding:"9px 20px 9px 16px", border:`1px solid ${likeClicked?"#1a73e8":"rgba(255,255,255,0.2)"}`, transform:`scale(${likeS})`, transformOrigin:"left center", boxShadow: likeClicked?"0 4px 18px rgba(26,115,232,0.55)":"0 4px 16px rgba(0,0,0,0.5)" }}>
            <span style={{ fontSize:18 }}>👍</span>
            <span style={{ color:"#fff", fontSize:13, fontWeight:800, fontFamily:inter, whiteSpace:"nowrap" }}>{likeClicked?"Liked!":"Like this video"}</span>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:8, background: subClicked?"#505050":"#FF0000", borderRadius:"0 24px 24px 0", padding:"9px 20px 9px 16px", transform:`scale(${subS})`, transformOrigin:"left center", boxShadow: subClicked?"none":"0 4px 18px rgba(255,0,0,0.6)" }}>
            <span style={{ fontSize:18 }}>🔔</span>
            <span style={{ color:"#fff", fontSize:13, fontWeight:800, fontFamily:inter, whiteSpace:"nowrap" }}>{subClicked?"Subscribed ✓":"Subscribe"}</span>
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
